import React, { useEffect } from "react";
import { usePrivileges } from "./context/PrivilegeContext";
import { useLocation } from "react-router-dom";

const ProtectedRoute = ({ privilege, children }) => {
  const { privileges } = usePrivileges();
  const location = useLocation();

  const hasAccess = privileges.includes(privilege);

  useEffect(() => {
    if (!hasAccess) {
      alert("You have no access to this page");
    }
  }, [hasAccess, location.pathname]); // runs every time route changes

  if (!hasAccess) {
    return null; // block render, stay on previous page
  }

  return children;
};

export default ProtectedRoute;
